import { resolveAuthProvider } from './auth-provider';
import { CognitoAuthAdapter } from './cognito-adapter';
import { SupabaseAuthAdapter } from './supabase-adapter';
import type { AuthAdapter } from './types';

const primaryProvider = resolveAuthProvider(
  import.meta.env.VITE_AUTH_PRIMARY_PROVIDER
);

const isLegacyAuthStorageKey = (key: string) =>
  key === 'supabase.auth.token' ||
  key.includes('supabase.auth.token') ||
  (key.startsWith('sb-') && key.endsWith('-auth-token'));

const clearLegacyAuthStorage = () => {
  if (typeof window === 'undefined') return;

  [window.localStorage, window.sessionStorage].forEach((storage) => {
    Object.keys(storage)
      .filter(isLegacyAuthStorageKey)
      .forEach((key) => storage.removeItem(key));
  });
};

const createAuthService = (): AuthAdapter => {
  if (primaryProvider === 'cognito') {
    clearLegacyAuthStorage();
    return new CognitoAuthAdapter();
  }
  return new SupabaseAuthAdapter();
};

export const authPrimaryProvider = primaryProvider;
export const authService = createAuthService();
